import { createSlice } from "@reduxjs/toolkit";
import {
  getMyProductsBuilder,
  createMyProductBuilder,
  updateMyProductBuilder,
  deleteMyProductBuilder,
} from "./builder";

const initialState = {
  myProducts: null,
  myProductsTotal: null,
  myProductsPage: 1,
  myProductsPerPage: 12,
  myProductsMaxReached: false,
  bandInfo: null,
  error: null,
  getMyProductsPending: false,
  createMyProductPending: false,
  updateMyProductPending: false,
  deleteMyProductPending: false,
};

export const bandProductsSlice = createSlice({
  name: "bandProducts",
  initialState,
  reducers: {
    clearMyProducts: (state) => {
      state.myProducts = null;
      state.myProductsTotal = null;
      state.myProductsPage = 1;
      state.myProductsMaxReached = false;
      state.bandInfo = null;
    },
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    getMyProductsBuilder(builder);
    createMyProductBuilder(builder);
    updateMyProductBuilder(builder);
    deleteMyProductBuilder(builder);
  },
});

export const { clearMyProducts, clearError } = bandProductsSlice.actions;

export default bandProductsSlice.reducer;